import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as Actions from '../../actions/actions';
import Animals from '../Helpers/Storage/Animals.json';
import Gender from '../Helpers/Storage/Gender.json';
import Castrated from '../Helpers/Storage/Castrated.json';
import Storage from '../Helpers/Storage/Storage';
import {
  AlertForm,
  FormInput,
  FormTextarea,
  FormCardGroup,
  RadioValues,
  FormImage,
  FormButton
} from '../Helpers/Form';


const editPet = props => {
  const {
    headText, changePet, petVm, dropfiles, history, onSubmit
  } = props;
  const {
    name, gender, species, castrated, description, image
  } = petVm;

  return (
    <div className="addPet">
      <h1>{headText}</h1>
      <AlertForm onSubmit={() => onSubmit(petVm, history)} onChange={target => changePet(target.name, target.value)} >
        <FormInput required text="Name" type="text" value={name} name="name" />
        <FormImage image={image || Storage.get(species)} alt={name} onDrop={dropfiles} />
        <FormCardGroup text="Tierart" required>
          <RadioValues selectedValue={species} possibleValues={Animals} name="species" />
        </FormCardGroup>
        <FormCardGroup text="Geschlecht">
          <RadioValues selectedValue={gender} possibleValues={Gender} name="gender" />
        </FormCardGroup>
        <FormCardGroup text="Kastriert / Unterbunden">
          <RadioValues selectedValue={castrated} possibleValues={Castrated} name="castrated" />
        </FormCardGroup>
        <FormTextarea name="description" text="Beschreibung" value={description} />
        <FormButton text="Speichern" />
      </AlertForm>
    </div>
  );
};

export default connect(
  state => ({ ...state.petReducer, ...state.currentUserReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(withRouter(editPet));



// WEBPACK FOOTER //
// ./src/pages/Pet/EditPet.js